__webpack_require__.p = "/world-of-mystery-monster-card/";